import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';

import * as SharedMaterialsDatabaseStateController from '../../store/StateControllers/SharedMaterials/SharedMaterialsDatabaseStateController';
import { SharedMaterialRequestComponentBase, getSharedMaterialRequestState } from './SharedMaterialRequestComponentBase';
import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';

interface ContactSupplierParamsType {
    companyId: string,
    sharedMaterialId?: string
};
   
class ContactSupplier extends SharedMaterialRequestComponentBase {

    // ===============================================================================

    protected getLocalizedTitle(): string{
        return this.localizeString("Contact Supplier");
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }

    // ===============================================================================

    protected renderForm(): JSX.Element {
        return (
            <div className="contact-supplier-form">
                <div className="grouped-data">
                    <div className="group">
                        <div className="title">{this.localizeString("Email Message")}</div>
                        <div className="content">
                            <textarea id="email-message-input" className="form-control" rows={10}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // ===============================================================================

    protected getLocalizedDescription() {
        const sharedMaterialId = this.getRouteParams<ContactSupplierParamsType>().sharedMaterialId;
        return sharedMaterialId
            ? this.localizeStringFormat("Contact a company by about {0}.", this.props.sharedMaterialsCoreDataMap[sharedMaterialId].materialName)
            : this.localizeString("Contact a supplier by email.");
    }

    // ===============================================================================

    protected submitButton_click = () => {
        const message = (document.getElementById("email-message-input") as HTMLTextAreaElement).value.trim();

        const params = this.getRouteParams<ContactSupplierParamsType>();

        this.props.contactCompany(params.companyId, message, params.sharedMaterialId);
    }
}

// ===============================================================================

export default connect(
    getSharedMaterialRequestState,
    SharedMaterialsDatabaseStateController.actionCreators // Selects which action creators are merged into the component's props
)(ContactSupplier as any);